import { useNavigate } from 'react-router-dom';
import { useBackgroundJobs } from '../../api/backgroundJobs';

/**
 * Finished and failed background work, announced wherever the reader is.
 *
 * A stack of its own rather than the shell's one-line toast: these carry a
 * link (View, Retry), stay long enough to be acted on, and more than one can
 * land at once — the analysis finishing queues five more jobs.
 */
export default function JobToasts() {
  const { toasts, dismiss } = useBackgroundJobs();
  const navigate = useNavigate();
  if (!toasts.length) return null;

  return (
    <div className="job-toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`job-toast ${t.tone}`}>
          <span className="job-toast-text">{t.tone === 'failed' ? '⚠ ' : '✓ '}{t.text}</span>
          {t.tone === 'done' && t.subject && (
            <button onClick={() => { dismiss(t.id); navigate(`/portfolios/${t.subject}`); }}>View</button>
          )}
          {t.onRetry && (
            <button onClick={() => { dismiss(t.id); t.onRetry(); }}>Retry</button>
          )}
          <button className="job-toast-x" aria-label="Dismiss" onClick={() => dismiss(t.id)}>×</button>
        </div>
      ))}
    </div>
  );
}
